import React from "react";
import { Icon } from "@iconify/react";

const BackLink = ({ href }) => {
  return (
    <a href={href} className="inline-flex gap-1 items-center">
      <Icon icon="mdi:chevron-left-circle" />
      <span>Back</span>
    </a>
  );
};

export default BackLink;
